import { render, staticRenderFns } from "./channelDataDetail.vue?vue&type=template&id=0a2db0bd"
import script from "./channelDataDetail.vue?vue&type=script&lang=js"
export * from "./channelDataDetail.vue?vue&type=script&lang=js"
import style0 from "./channelDataDetail.vue?vue&type=style&index=0&id=0a2db0bd&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports